<template>
  <span :class="style.heading">Сайт</span>
  <div :class="style.inputs">
    <InputStyle
      size="M"
      placeholder="www.site.ru"
      description="Домен сайта"
      v-model="localIntegration.domain"
      @blur="onDomainBlur"
    />
    <InputStyle
      size="M"
      placeholder="<script></script>"
      description="Скрипт"
      v-model="script"
      readOnly
    />
  </div>
  <div :class="style.buttons">
    <PrimaryButton
      :text="edit ? 'Сохранить' : 'Добавить интеграцию'"
      @click="saveIntegration"
    />
    <SecondaryButton
      text="Удалить"
      v-if="edit"
      :icon="trashIcon"
      @click="$emit('delete')"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./settingIntegrations.module.scss";
import PrimaryButton from "@/elements/UI/button/ButtonStyle/Default/primary/PrimaryButton.vue";
import SecondaryButton from "@/elements/UI/button/ButtonStyle/Default/secondary/SecondaryButton.vue";
import trashIcon from "$images/icons/button/Name=Trash, Size=16, Tone=Default.svg";
import {DOMAIN} from "@/http";
import InputStyle from "@/elements/UI/input/Style/InputStyle.vue";

export default defineComponent({
  name: "SettingIntegrationWebSite",
  components: {InputStyle, SecondaryButton, PrimaryButton},
  emits: ["delete", "closeModal"],
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    integration: {
      type: String,
      default: ""
    },
    integrationIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      style,
      trashIcon,
      localIntegration: {
        domain: this.integration ?? ""
      },
      DOMAIN,
      script: ""
    };
  },
  mounted() {
    this.script = this.getScript();
  },
  methods: {
    saveIntegration() {
      const integration = this.getIntegration.webSite;

      if (!integration) return;

      if (
        this.edit &&
        this.integrationIndex >= 0 &&
        this.integrationIndex < integration.integration.length
      ) {
        integration.integration[this.integrationIndex] =
          this.localIntegration.domain;
      } else {
        integration.integration.push(this.localIntegration.domain);
      }

      this.$emit("closeModal");
    },
    getScript() {
      let script = `<script src=\"https://${this.DOMAIN}/api/js?id=${this.getUser._id}\"><\/script>`;
      script = script.replace(/[\n\r]+/g, "").replace(/\s{2,10}/g, " ");
      return script;
    },
    normalizeDomain(value: string): string {
      if (!value) return "";

      let domain = value.trim().toLowerCase();

      domain = domain.replace(/^https?:\/\//, "");
      domain = domain.replace(/^www\./, "");
      domain = domain.split("/")[0];

      const parts = domain.split(".");
      const tld = parts[parts.length - 1];

      const VALID_TLDS = ["ru", "com", "net", "org", "io", "dev"];

      if (!VALID_TLDS.includes(tld)) {
        domain += ".ru";
      }

      return domain;
    },
    isValidDomain(domain: string): boolean {
      return /^[a-z0-9.-]+\.[a-z]{2,}$/.test(domain);
    },
    onDomainBlur() {
      const normalized = this.normalizeDomain(this.localIntegration.domain);

      if (this.isValidDomain(normalized)) {
        this.localIntegration.domain = normalized;
      }
    }
  },
  computed: {
    getUser() {
      return this.$userStore.getUser;
    },
    getIntegration() {
      return this.$integrationStore.getIntegration;
    }
  },
  watch: {
    integration: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (!newVal) return;

        this.localIntegration = {
          domain: newVal || ""
        };
      }
    }
  }
});
</script>
